module.exports = new __parcel__URL__("switch2.37c55742.ogg").toString();